import { defineComponent as _defineComponent } from 'vue'
import { normalizeStyle as _normalizeStyle, createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = { class: "BaseEchart" }

import { EChartsOption } from 'echarts'
import { onMounted, ref, withDefaults, watchEffect } from 'vue'
import useEchart from '@/hooks/useEchart'


export default /*#__PURE__*/_defineComponent({
  __name: 'BaseEchart',
  props: {
    width: { default: '100%' },
    height: { default: '360px' },
    options: {}
  },
  setup(__props: any) {

const props = __props

const echartDivRef = ref<HTMLElement>()
onMounted(() => {
  const { setOption } = useEchart(echartDivRef.value!)

  watchEffect(() => {
    setOption(props.options)
  })
})

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", {
      ref_key: "echartDivRef",
      ref: echartDivRef,
      style: _normalizeStyle({ width: _ctx.width, height: _ctx.height })
    }, null, 4)
  ]))
}
}

})